// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "tr.disabled[data-v-63cc4aa7] {\n  color: #c1c1c1;\n}\ntd[data-v-63cc4aa7]:first-child {\n  display: flex;\n  justify-content: space-between;\n}\ntd[data-v-63cc4aa7] {\n  position: relative;\n}\nbutton[data-v-63cc4aa7] {\n  vertical-align: middle;\n}\n.absolute-center[data-v-63cc4aa7] {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n", ""]);
// Exports
module.exports = exports;
